'use client';

import { useMemo } from 'react';

import { trackWithCommonMetadata, TransformerMap } from './tracker';
import { Sentiment } from '@ui/Dallas/Forms/DallasSentimentRatingField/DallasSentimentRatingField';
import useAnalyticsCommonMetadataSession from './common-metadata/useAnalyticsCommonMetadataSession';
import useAnalyticsCommonMetadataUser from './common-metadata/useAnalyticsCommonMetadataUser';

type FeedbackAnalyticsEventMetadata = {
  FEEDBACK: {
    comments: string;
    sentiment: Sentiment | null;
  };
};

/** Metadata transformers for each event, if applicable. */
const feedbackAnalyticsEventMetadataTransformers: TransformerMap<FeedbackAnalyticsEventMetadata> =
  {
    FEEDBACK: ({
      comments,
      sentiment,
    }): {
      feedback: { comments: string; sentiment: Sentiment | null };
    } => ({ feedback: { comments, sentiment } }),
  };

export default function useTrackAnalyticsEventFeedback() {
  const sessionMetadata = useAnalyticsCommonMetadataSession();
  const userMetadata = useAnalyticsCommonMetadataUser();

  return useMemo(
    () =>
      trackWithCommonMetadata(
        [userMetadata, sessionMetadata],
        feedbackAnalyticsEventMetadataTransformers,
      ),
    [userMetadata, sessionMetadata],
  );
}
